module.exports = __webpack_public_path__ + "static/img/jump.f43e5f47.webp";